export function isNonEmptyString(s: any): s is string {
  return s !== undefined && s !== null && typeof s === 'string' && s.length > 0
}
